import { featureCollection, type LineString } from '@turf/helpers';
import { useMemo } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import useMap from '../../hooks/useMap';
import useMapStyleChange from '../../hooks/useMapStyleChange';
import { chevronsBottomId, chevronsTopId, getLayerBeforeId } from '../../utils/layers';

const sourceId = 'empty-chevron-source';

type Props = {};

const EmptyChevronLayers = ({}: Props) => {
  const map = useMap();
  const data = useMemo(() => featureCollection<LineString>([]), []);
  useMapStyleChange(map);

  return (
    <Source id={sourceId} type="geojson" data={data}>
      <Layer id={chevronsTopId} beforeId={getLayerBeforeId(map, chevronsTopId)} type="symbol" source={sourceId} />
      <Layer id={chevronsBottomId} beforeId={chevronsTopId} type="symbol" source={sourceId} />
    </Source>
  );
};

export default EmptyChevronLayers;
